import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios/axios-base';
import clsx from 'clsx';
import SimpleLoader from 'components/loaders/SimpleLoader';
import { useDispatch } from 'react-redux';
import { getLocationsThunk } from 'store/mockServices/mockServiceList/mockServiceListActions';
import BzmIcon from '../icons/BzmIcon';

type RefreshLocationsBtnProps = {
  variant: 'button' | 'circle';
  disabled?: boolean;
  onLocationRefresh?: () => void;
};

const RefreshLocationsBtn = (props: RefreshLocationsBtnProps) => {
  const { variant, disabled } = props;
  const [isFetching, setIsFetching] = useState(false);

  const dispatch = useDispatch();

  const refreshLocationsHandler = async () => {
    setIsFetching(true);
    try {
      await axios.post(`/workspaces/{workspaceId}/locations/synchronize`);
      await dispatch(getLocationsThunk());
    } catch (e) {
    } finally {
      setIsFetching(false);
      // Propagate
      if (props.onLocationRefresh) {
        props.onLocationRefresh();
      }
    }
  };

  return (
    <Button
      style={{ width: '144px' }} //Fix width is because we will show the loader inside
      disabled={isFetching || disabled}
      className={clsx(
        variant === 'circle' ? 'btn-circular btn-large btn-jb' : 'outline-secondary',

        //Spinning animation for circle
        variant === 'circle' && isFetching ? 'spinning-animation' : '',
      )}
      onClick={refreshLocationsHandler}
      variant={variant === 'circle' ? 'primary' : 'secondary'}
      title="Refresh Locations"
    >
      {isFetching && variant === 'button' ? (
        <SimpleLoader loadingText={'Refreshing...'} />
      ) : (
        <>
          <BzmIcon variant={'icon-bzm-sync'} className={variant === 'button' ? 'mr-2' : ''}></BzmIcon>
          {variant === 'button' && <span>Refresh Locations</span>}
        </>
      )}
    </Button>
  );
};

export default RefreshLocationsBtn;
